import {usePageContext} from "vike-react/usePageContext";
import {AppPageContext, DataWrapped} from "#/src/definitions/AppDefinitions";
import {useData} from "vike-react/useData";
import {ApiAdBanner, ApiLivestreamData} from "#/src/definitions/ApiDefinitions";
import {AdWrapper} from "#/src/components/AdWrapper";
import {AttachmentNamespace, Attachments} from "#/src/utils/attachment-storage";
import styled from "@emotion/styled";
import AppConstants from "#/src/utils/app-constants";
import {Adsense} from "@ctrl/react-adsense";

const AdPlacement = styled.div`
  display: flex;
  justify-content: center;
`;

const NegativeWrapper = styled.div`
    --negative-wrapper-margin: -4.55rem;
    margin-top: var(--negative-wrapper-margin);

    @media (min-width: 336px) {
        --negative-wrapper-margin: -9.25rem !important;
    }
`;

export function AdSection() {
  const {user} = usePageContext() as AppPageContext;
  const {data: livestreamData} = useData() as DataWrapped<ApiLivestreamData>;
  const mode = user.lightMode ? "LIGHT" : "DARK";
  const ad = livestreamData.adData.find((adData: ApiAdBanner) => adData.placement == "LIVE_AND_STREAMS" && adData.theme == mode);

  function renderAd() {
    if (!ad) {
      return <NegativeWrapper>
        <Adsense client={AppConstants.ADSENSE_CLIENT_ID} slot={"8213168607"} className={"campaign-banner type-750x200-adsense"} format={null} data-banner-id={"adsense-stream"}/>
      </NegativeWrapper>
    }
    return <NegativeWrapper className={"campaign-banner type-750x200"}>
      <AdWrapper ad={ad}>
        <img alt={ad.alt} src={Attachments.getUrl(AttachmentNamespace.AD, ad)}/>
      </AdWrapper>
    </NegativeWrapper>
  }

  return <AdPlacement className={"live-ad-section text-center my-5"}>{renderAd()}</AdPlacement>
}